import React from 'react';
import OrderAndPaymentHistory from '../OrderAndPaymentHistory/OrderAndPaymentHistory';

const BillingAndOrders: React.FC = () => {
  return (
    <OrderAndPaymentHistory />
  );
};

export default BillingAndOrders;
